(function() {
  function init() {

    /* ============================================
       HERO — Animation au loading
       ============================================ */
    var hero = document.querySelector('[id$="__hero_banner"]');
    if (hero) {
      var heroTitle = hero.querySelector('h1, h2, .title');
      var heroText = hero.querySelector('p, .description');
      var heroBtns = hero.querySelector('.buttons, .button-group, [class*="btn"]');

      [heroTitle, heroText, heroBtns].forEach(function(el, i) {
        if (!el) return;
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'none';
        setTimeout(function() {
          el.style.transition = 'opacity 0.8s cubic-bezier(0.4,0,0.2,1), transform 0.8s cubic-bezier(0.4,0,0.2,1)';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, 200 + (i * 200));
      });
    }

    /* ============================================
       SCROLL REVEAL — Tous les éléments
       ============================================ */
    var revealSelectors = [
      '[id$="__story_section_1"] .image-text__media',
      '[id$="__story_section_1"] .image-text__content',
      '[id$="__story_section_2"] .image-text__media',
      '[id$="__story_section_2"] .image-text__content',
      '[id$="__noxor_why_us_about"] .noxor-why-us__row',
      '[id$="__stats_section"] .multicolumn-list__item',
      '[id$="__testimonials"] .testimonial-inner',
    ];

    var allRevealEls = [];
    revealSelectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        allRevealEls.push(el);
      });
    });

    /* État initial */
    allRevealEls.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.7s cubic-bezier(0.4,0,0.2,1), transform 0.7s cubic-bezier(0.4,0,0.2,1)';
    });

    /* IntersectionObserver global */
    var scrollObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = allRevealEls.indexOf(entry.target);
        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, 80);
        scrollObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    allRevealEls.forEach(function(el) { scrollObserver.observe(el); });

    /* ============================================
       STORY SECTION 1 — Timed reveal (already in viewport at load)
       ============================================ */
    var s1 = document.querySelector('[id$="__story_section_1"]');
    if (s1) {
      var s1els = s1.querySelectorAll('.image-media, .image-text .heading, .image-text .image-with-text__text, .image-text .action');

      s1els.forEach(function(el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)';
      });

      function revealS1() {
        s1els.forEach(function(el, i) {
          setTimeout(function() {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }, 400 + (i * 150));
        });
      }

      /* If already in viewport, trigger on load; otherwise use observer */
      var s1rect = s1.getBoundingClientRect();
      if (s1rect.top < window.innerHeight && s1rect.bottom > 0) {
        setTimeout(revealS1, 50);
      } else {
        var s1observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            revealS1();
            s1observer.disconnect();
          });
        }, { threshold: 0.1 });
        s1observer.observe(s1);
      }
    }

    /* STORY SECTION 2 — image à droite */
    var s2 = document.querySelector('[id$="__story_section_2"]');
    if (s2) {
      var s2media = s2.querySelector('.image-media');
      var s2heading = s2.querySelector('.image-text .heading');
      var s2text = s2.querySelector('.image-text .image-with-text__text');

      if (s2media) { s2media.style.opacity = '0'; s2media.style.transform = 'translateX(40px)'; s2media.style.transition = 'opacity 0.8s cubic-bezier(0.4,0,0.2,1), transform 0.8s cubic-bezier(0.4,0,0.2,1)'; }
      if (s2heading) { s2heading.style.opacity = '0'; s2heading.style.transform = 'translateY(20px)'; s2heading.style.transition = 'opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s'; }
      if (s2text) { s2text.style.opacity = '0'; s2text.style.transform = 'translateY(20px)'; s2text.style.transition = 'opacity 0.7s ease 0.25s, transform 0.7s ease 0.25s'; }

      var s2observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          [s2media, s2heading, s2text].forEach(function(el) {
            if (el) { el.style.opacity = '1'; el.style.transform = 'translate(0,0)'; }
          });
          s2observer.disconnect();
        });
      }, { threshold: 0.15 });
      s2observer.observe(s2);
    }

    /* ============================================
       STATS — Stagger + counter animation
       ============================================ */
    function animateCounter(el) {
      var text = el.textContent.trim();
      var suffix = text.replace(/[\d.]/g, '');
      var num = parseFloat(text.replace(/[^\d.]/g, ''));
      if (isNaN(num)) return;
      var duration = 1500;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * num) + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = text;
      }
      requestAnimationFrame(step);
    }

    var statItems = document.querySelectorAll('[id$="__stats_section"] .multicolumn-list__item');
    var statsObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(statItems).indexOf(entry.target);
        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          var counter = entry.target.querySelector('h3.title');
          if (counter) animateCounter(counter);
        }, index * 150);
        statsObserver.unobserve(entry.target);
      });
    }, { threshold: 0.2 });
    statItems.forEach(function(item) { statsObserver.observe(item); });

    /* ============================================
       WHY NOXOR — Stagger rows
       ============================================ */
    var whyRows = document.querySelectorAll('[id$="__noxor_why_us_about"] .noxor-why-us__row');
    var whyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(whyRows).indexOf(entry.target);
        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          entry.target.classList.add('noxor-why-us__row--visible');
        }, index * 200);
        whyObserver.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    whyRows.forEach(function(row) { whyObserver.observe(row); });

    /* ============================================
       TESTIMONIALS — Stagger cards
       ============================================ */
    var testimonials = document.querySelectorAll('[id$="__testimonials"] .testimonial-inner');
    var testObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(testimonials).indexOf(entry.target);
        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, index * 150);
        testObserver.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    testimonials.forEach(function(t) { testObserver.observe(t); });

    /* ============================================
       INJECT STATS sous Built on Innovation
       ============================================ */
    var content = document.querySelector('[id$="__story_section_1"] .image-text__content');
    if (content && !content.querySelector('.noxor-about-stats')) {
      var stats = document.createElement('div');
      stats.className = 'noxor-about-stats';
      stats.innerHTML =
        '<div class="noxor-about-stat"><span class="noxor-about-stat__val">15+</span><span class="noxor-about-stat__lbl">Years in Business</span></div>' +
        '<div class="noxor-about-stat"><span class="noxor-about-stat__val">4M+</span><span class="noxor-about-stat__lbl">Sq Ft Protected</span></div>' +
        '<div class="noxor-about-stat"><span class="noxor-about-stat__val">25yr</span><span class="noxor-about-stat__lbl">Product Warranty</span></div>';
      var btn = content.querySelector('.action');
      if (btn) content.insertBefore(stats, btn);
      else content.appendChild(stats);
      stats.style.opacity = '0';
      stats.style.transform = 'translateY(20px)';
      stats.style.transition = 'opacity 0.7s ease 0.5s, transform 0.7s ease 0.5s';
      setTimeout(function() { stats.style.opacity = '1'; stats.style.transform = 'translateY(0)'; }, 50);
    }

  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
